module.exports = __webpack_public_path__ + "img/hest3.45c4fbde.jpg";